import React from 'react';
import { ArrowRightIcon, TruckIcon } from '@heroicons/react/24/outline';
import styles from './GhostMoveCard.module.css';

export interface GhostSuggestion {
  id: number;
  insertion_type: 'before_first' | 'between' | 'after_last';
  before_pronumber: number | null;
  before_legnum: number | null;
  after_pronumber: number | null;
  after_legnum: number | null;
  pronumber: number;
  legnum: number;
  total_score: number;
  distance_score: number;
  deadhead_to_origin_miles: number;
  deadhead_from_dest_miles: number | null;
  move_type: string | null;
  origin_city: string | null;
  origin_state: string | null;
  dest_city: string | null;
  dest_state: string | null;
  customer_name: string | null;
  appointment_time: string | null;
  rank_at_position: number;
}

interface GhostMoveCardProps {
  suggestion: GhostSuggestion;
  onClick: (suggestion: GhostSuggestion) => void;
}

export const GhostMoveCard: React.FC<GhostMoveCardProps> = ({ suggestion, onClick }) => {
  const scorePercent = Math.round(suggestion.total_score * 100);

  const formatLocation = (city: string | null, state: string | null) => {
    if (!city && !state) return 'Unknown';
    if (!state) return city || 'Unknown';
    if (!city) return state;
    return `${city}, ${state}`;
  };

  return (
    <div
      className={styles.ghostCard}
      onClick={() => onClick(suggestion)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && onClick(suggestion)}
    >
      <div className={styles.scoreDisplay}>{scorePercent}%</div>
      <div className={styles.suggestedBadge}>Suggested</div>

      <div className={styles.moveType}>{suggestion.move_type || 'MOVE'}</div>
      <div className={styles.proNumber}>
        {suggestion.pronumber}-{suggestion.legnum}
      </div>

      <div className={styles.route}>
        <span className={styles.location}>
          {formatLocation(suggestion.origin_city, suggestion.origin_state)}
        </span>
        <ArrowRightIcon className={styles.routeArrow} width={14} height={14} />
        <span className={styles.location}>
          {formatLocation(suggestion.dest_city, suggestion.dest_state)}
        </span>
      </div>

      {suggestion.customer_name && (
        <div className={styles.customer}>{suggestion.customer_name}</div>
      )}

      <div className={styles.deadheadInfo}>
        <div className={styles.deadheadItem}>
          <TruckIcon width={12} height={12} />
          <span>{suggestion.deadhead_to_origin_miles.toFixed(0)} mi to pickup</span>
        </div>
        {suggestion.deadhead_from_dest_miles !== null && (
          <div className={styles.deadheadItem}>
            <span>{suggestion.deadhead_from_dest_miles.toFixed(0)} mi to next</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default GhostMoveCard;
